import React from 'react';
import BannerCollage from './BannerCollage';
import { BannerCollageProps } from './types';

const BannerCollageContainer = ({
  collage,
  displayType,
}: BannerCollageProps) => (
  <BannerCollage collage={collage} displayType={displayType} />
);

export default BannerCollageContainer;
